import { render, staticRenderFns } from "./Integraciones.vue?vue&type=template&id=87b74228"
import script from "./Integraciones.vue?vue&type=script&lang=js"
export * from "./Integraciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports